var _a, _b;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './AddActionView.html';
import { translate } from 'angular';
import { AddAction, } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/components/addAction/addAction.dispatcher';
import { ActionViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/ActionViewModel';
import { ActionFeatures } from '../../../actions/ActionFeatures';
import './addAction.scss';
import { BuilderAiAgentService } from '../../../../services/BuilderAiAgentService';
import { AiAgentSidebarStateService } from '../../../../aiAgent/services/AiAgentSidebarStateService';
let AddActionComponent = class AddActionComponent {
    static $inject = ['$translate', 'AiAgentSidebarStateService'];
    constructor($translate, AiAgentSidebarStateService) {
        'ngInject';
        this.$translate = $translate;
        this.AiAgentSidebarStateService = AiAgentSidebarStateService;
    }
    //#endregion
    async checkFeatures() {
        this.isProcessContentAssistantEnabled = await ActionFeatures.isActionProcessContentAssistantEnabled();
        this.isActionExecuteTemplateEnabled = await ActionFeatures.isActionExecuteTemplateEnabled();
        this.isActionExecuteScriptV2Enabled = await ActionFeatures.isActionExecuteScriptV2Enabled();
        this.isActionExecuteBlipFunctionEnabled = await ActionFeatures.isActionExecuteBlipFunction();
    }
    $onInit() {
        this.checkFeatures();
    }
    $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
        else {
            throw new Error('onAction is not implemented');
        }
    }
    openModal(modalName) {
        this.AiAgentSidebarStateService.open(modalName, null);
    }
    openActionModal() {
        this.AiAgentSidebarStateService.open('ActionsOptionList', {
            onAddAction: this.onAddAction.bind(this),
            addActionText: this.addActionText,
        });
    }
    onAddAction(type) {
        if (type === 'IntegrateMCP') {
            return this.openModal(type);
        }
        const action = new AddAction({
            action: new ActionViewModel({
                type,
                $title: this.getActionTypeTitle(type),
            }),
        });
        this.$dispatch(action);
    }
    getActionTypeTitle(type) {
        if (BuilderAiAgentService.isAiAgentState(this.state.id)) {
            return (this.$translate
                .instant('ai-agent-actions.actionName.exampleActionName') +
                '_' +
                (this.state.$localCustomActions?.length + 1));
        }
        const toCamelCase = (value) => value.charAt(0).toLowerCase() + value.slice(1);
        const translateResource = `builder-tabs-actions.${toCamelCase(type.toString())}.title`;
        return this.$translate.instant(translateResource);
    }
    isActionProcessContentAssistantEnabled() {
        return this.isProcessContentAssistantEnabled;
    }
};
//#endregion
//#region Constructor
AddActionComponent.$inject = ['$translate', 'AiAgentSidebarStateService'];
AddActionComponent = __decorate([
    Component({
        template,
        bindings: {
            state: '=',
            onAction: '&?',
            onOpenActionModal: '&?',
            addActionText: '@?',
            isDisabled: '<?',
            isSubflowApplication: '<?',
            isAiAgentState: '<?',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _a : Object, typeof (_b = typeof AiAgentSidebarStateService !== "undefined" && AiAgentSidebarStateService) === "function" ? _b : Object])
], AddActionComponent);
export { AddActionComponent };
AddActionComponent.$inject = [
    '$translate',
    'AiAgentSidebarStateService',
];
